import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBResumeDocumentType = Database["public"]["Enums"]["resume_document_type"];

export const ResumeDocumentType = {
	RESUME: "resume",
	COVER_LETTER: "cover_letter",
	REFERENCE: "reference",
} as const satisfies Record<string, DBResumeDocumentType>;

export type ResumeDocumentType = (typeof ResumeDocumentType)[keyof typeof ResumeDocumentType];

type _EnsureAllDBValues = Exclude<DBResumeDocumentType, ResumeDocumentType> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const RESUME_DOCUMENT_TYPES = Object.values(ResumeDocumentType) as readonly ResumeDocumentType[];

export const resumeDocumentTypeSchema = z.enum(ResumeDocumentType);
